import i18n from 'i18next';
import resBundle from './assets/i18n';

export default function i18nConfig() {
  i18n.init({
    fallbackLng: 'en',

    debug: true,

    ns: ['translation'],
    defaultNS: 'translation',

    resources: resBundle,

    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    }
  });

  return i18n;
}



// WEBPACK FOOTER //
// ./src/i18n.js